import Swal from 'sweetalert2';

export const SweetSweetAlert = async ({ sweetData, icon, text, buttonColor, buttonText }) => {
  await Swal.fire({
    icon: icon,
    title: sweetData,
    text: text,
    showConfirmButton: true,
    confirmButtonColor: buttonColor,
    confirmButtonText: buttonText ? buttonText : 'OK',
    width: '400px',
    heightAuto: false,
    customClass: {
      icon: 'custom-swal-icon', // Add a custom class for the icon size
      title: 'custom-swal-title',
    },
  });
};
